import React from 'react';
import { LOW_CONFIDENCE_TEXT } from './reportFormat';
import { round1 } from './sentimentReportView';

const TRACKING_COLOR = 'var(--brand-600)';
const LOW_CONFIDENCE_OPACITY = 0.35;

interface DotPayload {
  event?: unknown;
  lowConfidence?: boolean;
  si?: number | null;
}

// Creator-post-event marker on the tracking line (Figma: white dot, brand ring);
// faded on a day with too few comments to trust.
export const TrackingDot = (props: { cx?: number; cy?: number; payload?: DotPayload }) => {
  const { cx, cy, payload } = props;
  if (!payload?.event || cx == null || cy == null) return null;
  const opacity = payload.lowConfidence ? LOW_CONFIDENCE_OPACITY : 1;
  return (
    <circle
      cx={cx}
      cy={cy}
      r={6}
      fill="#ffffff"
      fillOpacity={opacity}
      stroke={TRACKING_COLOR}
      strokeOpacity={opacity}
      strokeWidth={2}
    />
  );
};

interface TooltipEntry {
  dataKey?: string;
  value?: number;
  payload?: DotPayload & { event?: { creator: string } | null };
}

export const CustomTooltip = ({ active, payload, label }: { active?: boolean; payload?: TooltipEntry[]; label?: string }) => {
  if (!active || !payload?.length) return null;
  const tracking = payload.find((p) => p.dataKey === 'tracking')?.value;
  const neg = payload.find((p) => p.dataKey === 'neg_pct')?.value;
  const row = payload[0]?.payload;
  const evt = row?.event;
  return (
    <div className="rounded-[10px] border border-border bg-card px-3.5 py-2.5 text-[12px] shadow-sm">
      <div className="mb-1 font-medium text-foreground">{label}</div>
      {tracking != null && (
        <div style={{ color: TRACKING_COLOR }}>
          Tracking score: <b>{round1(tracking)}</b>
        </div>
      )}
      {tracking != null && row?.lowConfidence && <div className="text-muted-foreground">{LOW_CONFIDENCE_TEXT}</div>}
      {row?.si != null && (
        <div className="text-muted-foreground">
          Cumulative: <b>{round1(row.si)}</b>
        </div>
      )}
      {neg !== undefined && (
        <div className="text-red-500">
          Negative: <b>{round1(neg)}%</b>
        </div>
      )}
      {evt && <div className="mt-1 text-muted-foreground">New post by {evt.creator}</div>}
    </div>
  );
};
